export const addPeer = (peer) => ({

	type    : 'ADD_PEER',
	payload : { peer }
});

export const removePeer = (peerId) => ({

	type    : 'REMOVE_PEER',
	payload : { peerId }
});

// replacePeerConsume
export const replacePeerConsume = (srcPeerId, destPeerId, consumerId) => ({

	type    : 'REPLACE_PEER_CONSUME',
	payload : {srcPeerId, destPeerId, consumerId }
});

export const clearPeers = () => ({

	type : 'CLEAR_PEERS'
});

export const setPeerDisplayName = (displayName, peerId) => ({

	type    : 'SET_PEER_DISPLAY_NAME',
	payload : { displayName, peerId }
});

export const setPeerVideoPaused = (peerId, flag) => ({

	type    : 'SET_PEER_VIDEO_PAUSED',
	payload : { peerId, flag }
});

export const setPeerVideoInProgress = (peerId, flag) => ({

	type    : 'SET_PEER_VIDEO_IN_PROGRESS',
	payload : { peerId, flag }
});

export const setPeerAudioInProgress = (peerId, flag) => ({

	type    : 'SET_PEER_AUDIO_IN_PROGRESS',
	payload : { peerId, flag }
});

export const setPeerScreenInProgress = (peerId, flag) => ({

	type    : 'SET_PEER_SCREEN_IN_PROGRESS',
	payload : { peerId, flag }
});

export const setPeerRaisedHand = (peerId, raisedHand, raisedHandTimestamp) => ({

	type    : 'SET_PEER_RAISED_HAND',
	payload : { peerId, raisedHand, raisedHandTimestamp }
});

export const setPeerAudioMute = (peerId, flag) => ({

	type    : 'SET_PEER_AUDIO_MUTE',
	payload : { peerId, audioMuted : flag}
});

export const setPeerVideoMute = (peerId, flag) => ({

	type    : 'SET_PEER_VIDEO_MUTE',
	payload : { peerId, videoMuted : flag}
});

export const setPeerIsCameraOn = (peerId, flag) => ({

	type    : 'SET_PEER_IS_CAMERA_ON',
	payload : { peerId, isCameraOn : flag}
});

/**
 * 音频设备是否可用
 */
export const setPeerAudioAvailable = (peerId, flag) => ({

	type    : 'SET_PEER_AUDIO_AVAILABLE',
	payload : { peerId, audioAvailable : flag}
});
/**
 * 视频设备是否可用
 */
export const setPeerVideoAvailable = (peerId, flag) => ({

	type    : 'SET_PEER_VIDEO_AVAILABLE',
	payload : { peerId, videoAvailable : flag}
});

export const setPeerRaisedHandInProgress = (peerId, flag) => ({

	type    : 'SET_PEER_RAISED_HAND_IN_PROGRESS',
	payload : { peerId, flag }
});

export const setPeerPicture = (peerId, picture) => ({

	type    : 'SET_PEER_PICTURE',
	payload : { peerId, picture }
});

export const addPeerRole = (peerId, role) => ({

	type    : 'ADD_PEER_ROLE',
	payload : { peerId, role }
});

export const removePeerRole = (peerId, role) => ({

	type    : 'REMOVE_PEER_ROLE',
	payload : { peerId, role }
});

export const setPeerKickInProgress = (peerId, flag) => ({

	type    : 'SET_PEER_KICK_IN_PROGRESS',
	payload : { peerId, flag }
});

export const setMutePeerInProgress = (peerId, flag) => ({

	type    : 'STOP_PEER_AUDIO_IN_PROGRESS',
	payload : { peerId, flag }
});

export const setStopPeerVideoInProgress = (peerId, flag) => ({

	type    : 'STOP_PEER_VIDEO_IN_PROGRESS',
	payload : { peerId, flag }
});

export const setStopPeerScreenSharingInProgress = (peerId, flag) => ({

	type    : 'STOP_PEER_SCREEN_SHARING_IN_PROGRESS',
	payload : { peerId, flag }
});

// 举手通知
export const setForceMutePeerRaisedHand = (peerId, raisedHand) => ({

	type    : 'SET_FORCE_MUTE_PEER_RAISED_HAND',
	payload : { peerId, raisedHand }
});

// 设置联席主持人(添加/删除)
export const setPeerCohost = (peerId, isCohost) => ({

	type    : 'SET_PEER_COHOST',
	payload : { peerId, isCohost }
});
